import { GeneTypeEnum } from "../../util/geneChart";

export interface IQuickPin {
  title: string;
  targetPath: string;
}

export type IQuickPins = { [key: string]: IQuickPin } | null;

export interface IRegistryLayoutStore {
  quickPins: IQuickPins;
  isPaneOpen?: boolean;
  isGeneMapView?: boolean;
  dateGeneMap?: string;
  typeGeneMap?: GeneTypeEnum;
  isCaseView?: boolean;
  isEditMode?: boolean;
  isAddMode?: boolean;
  registryId?: string;
  hiddenColumns: string[];
}

export const registryLayoutStoreInitialState: IRegistryLayoutStore = {
  quickPins: {},
  isPaneOpen: false,
  isGeneMapView: false,
  isCaseView: false,
  isEditMode: false,
  isAddMode: false,
  hiddenColumns: [],
};
